import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import StepperNavigationButtons from "../StepperNavigationButtons";
import Story from "./Story";
import { IconPlus } from '@tabler/icons-react'

const Stories = forwardRef(
  function Stories(props, ref) {
    const [stories, setStories] = useState([]);

    useEffect(() => {
      if (props.data) {
        setStoriesData(props.data);
      }
    }, [props.data]);

    const setStoriesData = (data) => {
      let storiesData = [];
      data.forEach((item, index) => {
        storiesData.push({
          title: item.title,
          date: item.date,
          description: item.description,
          image: item.image,
          imageFile: item.imageFile,
          show: index == 0,
          isValid: false,
          ref: null,
          imageKey: item.imageKey
        })
      });

      setStories(storiesData);
    }

    const handleAddStory = () => {
      let story =
      {
        title: "Story " + (stories.length + 1),
        date: "",
        description: "",
        image: "",
        imageFile: null,
        show: stories.length == 0,
        isValid: false,
        ref: null,
        imageKey: ""
      }

      setStories([...stories, story]);
    }

    const showHideStory = (index) => {
      const currentStories = [...stories];

      currentStories.forEach((story, innerIndex) => {
        if (index == innerIndex)
          story["show"] = !story["show"];
        else
          story["show"] = false;
      });

      setStories(currentStories);
    }

    const deleteStoryHandler = (targetIndex) => {
      const filteredStories = stories.filter((item, index) => index !== targetIndex);

      if (filteredStories.length == 1) {
        filteredStories[0]["show"] = true;
      }

      const deletedStory = stories.filter((item, index) => index === targetIndex);

      if (deletedStory && deletedStory.length > 0) {
        if (deletedStory[0].imageKey != "")
          props.imageDelete(deletedStory[0].imageKey);
      }

      setStories(filteredStories);
    }

    const imageDeleteHandler = (imageKey) => {
      props.imageDelete(imageKey);
    }

    const validate = () => {
      let isValid = true;
      const currentStories = [...stories];
      currentStories.forEach(story => {
        let validationStatus = story.ref?.validate() ?? false;
        story["isValid"] = validationStatus;

        if (!validationStatus) {
          isValid = false;
        }
      });
      setStories(currentStories);
      return isValid;
    }

    const getData = () => {
      let storiesData = [];

      stories.forEach(story => {
        let data = story.ref?.getData() ?? null;
        if (data)
          storiesData.push(data);
      });
      return storiesData;
    }

    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));

    return (
      <div className="content d-block visible">
        <div className="content-header mb-3 d-flex justify-content-between">
          <div className="sec-titler">
            <h2 className="text-primary">Stories</h2>
            <div className="title-shape"></div>
            <small className="fs-11 mb-0"></small>
          </div>
          <div className="mb-0 text-right">
            <button className="btn btn-primary align-middle" onClick={handleAddStory}>
              <IconPlus className="me-sm-1 me-0" size={20} />
              Add Story
            </button>
          </div>
        </div>
        <div className="row g-3">
          <div className="accordion mt-3">
            {
              (!stories || (stories && stories.length == 0)) && (
                <div className="row justify-content-center">
                  <div className="col-md-5 col-lg-4 col-11">
                    <div className="d-flex flex-column align-items-center">
                      <img src="/images/story.svg" />
                      <div className="helper-message">
                        No story information<br /> Get started by creating
                      </div>
                      <button type="button" className="mt-2 btn btn-primary btn btn-secondary" onClick={handleAddStory}>
                        <IconPlus className="me-sm-1 me-0" size={20} />
                        Add Story
                      </button>
                    </div>
                  </div>
                </div>
              )
            }

            {stories && stories.length > 0 &&
              stories.map((story, index) => {
                return (
                  <Story
                    data={story}
                    index={index}
                    showHideStory={showHideStory}
                    deleteStory={deleteStoryHandler}
                    imageDelete={imageDeleteHandler}
                    key={index}
                    ref={el => story.ref = el} />
                )
              })
            }
          </div>

          <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} />
        </div>
      </div>
    )
  });

export default Stories;
